import { Injectable } from "@angular/core";
import { Observable, Subject } from "rxjs";
import { Theme, validThemes } from "../models/theme.model";
import { LocalStorageService } from "../service/localStorage.service";

@Injectable({
  providedIn: "root",
})
export class ThemeService {
  private _activeTheme: Theme;
  private subject = new Subject<Theme>();

  constructor(private localStorageService: LocalStorageService) {
    this.loadTheme();
  }

  public get activeTheme(): Theme {
    return this._activeTheme;
  }

  public themeChanged(): Observable<Theme> {
    return this.subject.asObservable();
  }

  public themeExists(theme) {
    return validThemes.includes(theme);
  }

  public changeTheme(theme: Theme): void {
    if (this.themeExists(theme)) {
      this.setTheme(theme);
      this.localStorageService.setItem("theme", theme);
    }
  }

  private setTheme(theme: Theme) {
    this._activeTheme = theme;

    const bodyElement = document.body;

    if (bodyElement) {
      bodyElement.setAttribute("data-theme", theme);
    }

    this.subject.next(theme);
  }

  private loadTheme(): void {
    let theme = this.localStorageService.getItem("theme");

    if (theme === "build-dark-theme") {
      theme = "midnight-dark-theme";
      this.localStorageService.setItem("theme", theme);
    }

    if (theme && validThemes.includes(theme)) {
      this.setTheme(theme);
    }
  }
}
